import { useState, useEffect } from 'react';
import { leaderboardEvents } from '../../../api/leaderboard-events';
import { offices } from '../../../api/offices';

interface UseOfficeOptionsProps {
  eventId: number;
  participantId?: number;
  allowedOfficeNames?: string;
  isOpen: boolean;
}

export const useOfficeOptions = ({
  eventId,
  participantId,
  allowedOfficeNames,
  isOpen,
}: UseOfficeOptionsProps) => {
  const [officeOptions, setOfficeOptions] = useState<{ value: string; label: string }[]>([]);

  useEffect(() => {
    const loadOffices = async () => {
      try {
        let options: { value: string; label: string }[] = [];

        if (participantId) {
          const participantOffices = await leaderboardEvents.getParticipantOffices(
            eventId,
            participantId
          );
          options = participantOffices.map((o: any) => ({ value: String(o.id), label: o.name }));
        } else {
          const allOffices = await offices.getByEventId(eventId);
          options = allOffices.map((o: any) => ({ value: String(o.id), label: o.name }));
        }

        let filteredOptions = options;
        if (allowedOfficeNames) {
          const names = allowedOfficeNames
            .split(',')
            .map((s) => s.trim().toLowerCase())
            .filter(Boolean);
          if (names.length) {
            const exact = filteredOptions.filter((opt) => names.includes(opt.label.toLowerCase()));
            filteredOptions =
              exact.length > 0
                ? exact
                : filteredOptions.filter((opt) =>
                    names.some((n) => opt.label.toLowerCase().includes(n))
                  );
          }
        }

        setOfficeOptions(filteredOptions);
      } catch {
        setOfficeOptions([]);
      }
    };

    if (isOpen) {
      loadOffices();
    }
  }, [eventId, participantId, allowedOfficeNames, isOpen]);

  return { officeOptions };
};
